import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {CHANGE_PASSWORD_URL, FIRST_TIME_CHANGE_PASSWORD_URL, LOGIN_URL, RESET_PASSWORD_URL} from '../config/url-config'

import {
    ERR_MSG,
    SESS_EXPIRED_TEXT,
    SUCCESS_CODES,
    CHANGE_PASSWORD_105,
    CHANGE_PASSWORD_101,
    CHANGE_PASSWORD_103,
    CHANGE_PASSWORD_104,
    CHANGE_PASSWORD_102,
    CHG_PWD_POLICY_ERR,
    CHANGE_PASSWORD_106,
    CURR_PASS_ERR,
    RESET_PASSWORD_200,
    RESET_PASSWORD_101,
    RESET_PASSWORD_102, RESET_PASSWORD_103, RESET_PASSWORD_104, RESET_PASSWORD_105, RESET_PASS_USERNAME_ERR
} from "../constants/constants";
import {store} from "../store/store";
import {loadSessionExpired} from "../store/action";
import {extractStatusCode} from "../helper/responsehelper";


export const resetPasswordStatus = {
    [RESET_PASSWORD_101]:ERR_MSG,
    [RESET_PASSWORD_102]:ERR_MSG,
    [RESET_PASSWORD_103]: RESET_PASS_USERNAME_ERR,
    [RESET_PASSWORD_104]: ERR_MSG,
    [RESET_PASSWORD_105]:ERR_MSG,
    "UNK-ERR-102": ERR_MSG,
};
const constructResetPasswordRequest = (formFields)=>(
    {
        userName:get(formFields,"userName"),
    }
)
export const resetPasswordService = (formFields)=>{
    const resetPaswordRequest = constructResetPasswordRequest(formFields)

    return new Promise((resolve,reject)=>{
        axiosInstance
            .post(RESET_PASSWORD_URL(),resetPaswordRequest)
            .then((response) => {
                let statusCode = extractStatusCode(response)
                console.log("change statusCode",statusCode)
                if(SUCCESS_CODES.RESET_PASSWORD.includes(statusCode)){
                    resolve(response)
                }else{
                    let errText = resetPasswordStatus[statusCode]
                    if(errText === SESS_EXPIRED_TEXT){
                        store.dispatch(loadSessionExpired(true))
                    }
                    reject(errText || ERR_MSG )
                }
            })
            .catch((error) => {
                console.log(error)
                reject(ERR_MSG)
            });
    })
}